<template>
    <div class="body-width divcss5">
        <div>
            <div class="div-row div-bottom news-Medium-24">
                海大智龙获得第九届“创客中国”大连市区域三等奖
                <!-- <span class="news-Regular-14">作者：何舒 来源：科技处 添加时间：2019-05-09 09:13:27</span> -->
            </div>
            <div class="div-text-left news-Regular-14b6">
                <span>2024-09-11</span><span class="div-padding-left">大连海大智龙科技有限公司</span>
            </div>
            <div class="div-line  divcss5"></div>

            <div class="div-row div-bottom10">
                <p class="indentation">
                    <strong>转载：第九届“创客中国”大连市区域赛决赛落幕 高新区企业夺魁</strong>
                </p>
            </div>

            <div class="div-row div-bottom10">
                <p class="indentation">
                    原创 大连高新 大连高新 2024年09月11日 17:04 辽宁
                </p>
            </div>

            <div class="div-row div-bottom10">
                <div class=" div-top box2">
                    <div class="div-margin ">
                        <img src="../../../assets/images/news29/1.gif" />
                    </div>
                </div>
            </div>

            <div class="div-row div-bottom10">
                <p class="indentation">
                    今日第九届“创客中国”大连市中小企业创新创业大赛决赛在高新区知你小企业创业基地圆满收官33个参赛项目进入决赛经过激烈的比拼高新区企业大连柏盛源科技有限公司在所有参赛项目中突出重围获得总决赛企业组一等奖据悉共有8家高新区企业入围总决赛分别荣获三等奖、优胜奖等荣誉
                    传承航海文化”为主题的“带你去航海”科普活动暨帆船邀请赛，大连海大智龙科技有限公司受邀参加。本次活动得到了中央电视台的大力支持，通过央视新闻客户端、微博、抖音、头条、B站等平台进行全平台全程直播。
                </p>
            </div>

            <div class="div-row div-bottom10">
                <div class=" div-top box2">
                    <div class="div-margin ">
                        <img src="../../../assets/images/news29/2.png" />
                    </div>
                </div>
            </div>

            <div class="div-row div-bottom10">
                <p class="indentation">
                    赛事由工业和信息化部网络安全产业发展中心（工业和信息化部信息中心）指导，大连市工业和信息化局精心组织，芝倪信息技术（大连）有限公司及芝吧（沈阳）信息技术有限公司大连分公司等支持。
                </p>
            </div>
            <div class="div-row div-bottom10">
                <p class="indentation">
                    本届大赛以“聚焦专精特新，创新创造未来”为主题，吸引了全市178个高质量项目竞相参与，同比增长32%。经过初赛的精彩比拼，33个项目（企业组21个，创客组12个）脱颖而出，涵盖了智能制造、工业互联网、新能源、新材料等前沿科技领域。
                    传承航海文化”为主题的“带你去航海”科普活动暨帆船邀请赛，大连海大智龙科技有限公司受邀参加。本次活动得到了中央电视台的大力支持，通过央视新闻客户端、微博、抖音、头条、B站等平台进行全平台全程直播。
                </p>
            </div>
            <div class="div-row div-bottom10">
                <p class="indentation">
                    这些参赛项目质量卓越、技术领先，以敏锐的市场洞察力精准对接行业需求，展现出强大的市场适应力和应用价值。同时，各参赛项目的优秀表现也集中展示了我市良好的创新创业生态，进一步擦亮“专精特新”金字招牌。决赛于9月10日举行，进入决赛的参赛项目以“7+5”的模式进行路演答辩，通过7分钟精炼展示与5分钟深入答辩，全面展示了各自的技术深度、市场广度与团队风采。为确保比赛的公平公正与奖项的实至名归，评委团从技术产品、行业市场、管理团队等方面进行严格评审。
                </p>
            </div>
            <div class="div-row div-bottom10">
                <p class="indentation">
                    最终，企业组与创客组分别评选出一等奖1名、二等奖2名、三等奖3名。企业组额外评选出优秀奖。其余入围决赛的企业组及创客组分别获得“专攻精进奖”和“特色育新奖”。大连赛区的优胜项目，将有机会踏上“创客中国”全国总决赛的舞台，与全国优秀项目同台竞技。
                </p>
            </div>
            <div class="div-row div-bottom10">
                <p class="indentation">
                    9月11日，大赛揭晓了决赛最终优胜者名单，并举行了颁奖典礼。其中，高新区企业大连柏盛源科技有限公司的参赛项目荣获企业组一等奖。在本届大赛上，高新区企业的精彩表现引人关注，共有8家企业登上决赛舞台，除柏盛源科技外，大连海大智龙科技有限公司、大连宇都环境工程技术有限公司等企业分获三等奖、优秀奖及“专攻精进”奖。
                </p>
            </div>

            <div class="div-row div-bottom10">
                <div class=" div-top box2">
                    <div class="div-margin ">
                        <img src="../../../assets/images/news29/3.png" />
                    </div>
                </div>
            </div>

            <div class="div-row div-bottom10">
                <p class="indentation">
                    大连柏盛源科技有限公司深耕智能车载安全监测系统多年，其自主研发的“高速列车全域安全卫士——覆盖CR300到CR450的多车型多方位多功能车载智能安全监测系统”荣获本届大赛一等奖。该项目可以准确提供监测部件的健康状态，推进修程优化，从而减少其维修频率，进而延长其生命周期。推动了高速动车组由“计划修”向“状态修”转变的预测性运维新模式。
                    传承航海文化”为主题的“带你去航海”科普活动暨帆船邀请赛，大连海大智龙科技有限公司受邀参加。本次活动得到了中央电视台的大力支持，通过央视新闻客户端、微博、抖音、头条、B站等平台进行全平台全程直播。
                </p>
                <p class="indentation">
                    大连海大智龙科技有限公司研发的项目“无人驾驶商船核心智能装备研制”专注技术突破，其核心产品“船舶智能电子海图及辅助决策避碰系统”，首次实现基于国际避碰规则的多船智能避碰，填补相关领域的空白。自主研发的“无人船仿真测试平台”“船舶智能配载及货物管理系统”等产品已达到世界领先水平。
                </p>
                <p class="indentation">
                    下一步，我市将为决赛优胜项目提供“量身定制”“即时响应”的全方位支持，促进项目跨越融资、孵化、成果转化等重重难关，加速创新成果向现实生产力转化。
                </p>
            </div>

            <div class="div-row div-bottom10">
                <div class=" div-top box2">
                    <div class="div-margin">
                        <img class="img2" src="../../../assets/images/news29/4.png" />
                    </div>
                </div>
            </div>

            <div class="div-row div-bottom10">
                <p class="indentation">
                    <strong>
                        大连高新
                    </strong>
                </p>
            </div>


            <div class="div-row div-bottom10">
                <p class="indentation">
                    关注高新技术产业 聚焦“又高又新”动态 服务特色孵化网络 传播创新创业文化
                </p>
                <p class="indentation">
                    833篇原创内容
                </p>
                <p class="indentation">
                    公众号
                </p>
            </div>

            <div class="div-row div-bottom10">
                <div class=" div-top box2">
                    <div class="div-margin">
                        <img src="../../../assets/images/news29/5.png" />
                    </div>
                </div>
            </div>

            <div class="div-row div-bottom10">
                <p class="indentation">
                    本条微信由大连高新编辑制作
                </p>
                <p class="indentation">
                    转载请注明：来源大连高新（微信号：daliangaoxin）
                </p>
                <p class="indentation">
                    文字：程誉慧
                </p>
                <p class="indentation">
                    资料：大赛组委会
                </p>
                <p class="indentation">
                    编辑：程誉慧
                </p>
                <p class="indentation">
                    责编：徐金娟
                </p>
            </div>

            <div class="div-row div-bottom10">
                <div class=" div-top box2">
                    <div class="div-margin">
                        <img src="../../../assets/images/news29/6.png" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            };
        },
        methods: {

        },
    };

</script>

<style scoped>
    .fl {
        float: right;
        margin-right: 20px;
    }

    .fy {
        text-align: center;
        margin-top: 30px;
    }

    .title {
        height: 100%;
    }

    .div-width {
        width: 75%;
    }



    .div-line {
        background: #E6E6E6;
        height: 1px;
        width: 100%;

    }

    .div-bottom10 {
        padding-top: 10px;
    }

    .div-bottom30 {
        padding-top: 30px;
        padding-bottom: 30px;
    }

    .div-top30 {
        padding-top: 30px;
    }

    img {
        vertical-align: middle;
        border-style: none;
        width: 95%;
        border-radius: 10px;
    }

    .img2 {
        text-align: left;
        width: 15%;
    }
</style>


// WEBPACK FOOTER //
// src/components/contentcoms/news2024/news29.vue